import { TDashboardRowItem } from "@/data/types";

export interface DashboardRowsState {
  items: TDashboardRowItem[];
  currentDashboardRow: TDashboardRowItem | null;
}

export const DefaultDashboardRowsState: DashboardRowsState = {
  items: [],
  currentDashboardRow: null,
};